import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import { createI18n } from 'vue-i18n'
import router from './router'
import App from './App.vue'

// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// vue-advanced-cropper styles
import 'vue-advanced-cropper/dist/style.css'

// i18n translations
import de from './locales/de.json'
import deCH from './locales/de-CH.json'
import { numberFormats } from './i18n'

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VSwitch: {
      color: 'primary'
    },
    VCardActions: {
      VBtn: {
        variant: 'elevated'
      }
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00'
        }
      }
    }
  }
})

// Create i18n instance
export const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de,
    'de-CH': deCH
  },
  numberFormats
})

// Create Pinia store
const pinia = createPinia()

// Create app
const app = createApp(App)

// Global alert plugin (ported from Vue 2)
import { useAlertStore } from './stores/alert'

app.config.globalProperties.$alert = function(message) {
  const alertStore = useAlertStore()

  if (!message.type) {
    message.type = 'info'
  }
  alertStore.add(message)
}

import { vuetifyProTipTap } from './tiptap.js'

// Use plugins
app.use(pinia)
app.use(router)
app.use(vuetify)
app.use(i18n)
app.use(vuetifyProTipTap)

// Mount app after checking auth
import { useAuthStore } from './stores/auth'

app.mount('#app')

// Initialize app after mount if JWT is valid
const authStore = useAuthStore()
if (authStore.validJWT) {
  authStore.initAppAfterLogin()
}
